module.exports = __webpack_public_path__ + "img/kp.770cb198.svg";